import React from "react";
import { IViewUserRequestModalUserDetailRowProps } from "./interface";
import { ZTypography } from "@atoms";
import { EFontWeights } from "@atoms/ZTypography/interface";

const ZViewUserRequestModalUserDetailRow: React.FC<
	IViewUserRequestModalUserDetailRowProps
> = ({ username, useremail }) => {
	return (
		<div className="p-4 bg-gray-3 my-2 rounded-md">
			<ZTypography.ZText
				className="block"
				colorVariant={10}
				level={1}
				weight={EFontWeights.MEDIUM}
			>
				User Details
			</ZTypography.ZText>
			<div>
				<div className="flex my-2">
					<ZTypography.ZText
						colorVariant={9}
						level={1}
						className="w-25"
					>
						Name :
					</ZTypography.ZText>
					<ZTypography.ZText colorVariant={9} level={1}>
						{username}
					</ZTypography.ZText>
				</div>
				<div className="flex">
					<ZTypography.ZText
						colorVariant={9}
						level={1}
						className="w-25"
					>
						Email Id :
					</ZTypography.ZText>
					<ZTypography.ZText colorVariant={9} level={1}>
						{useremail}
					</ZTypography.ZText>
				</div>
			</div>
		</div>
	);
};

export default ZViewUserRequestModalUserDetailRow;
